import { object, string, number, date } from "yup";
export const posConnectionSchema = object({

  vpDisplayName: string()
    .min(3, "POS adi 3 karakterden kısa olamaz")
    .max(50, "POS adi 50 karakterden uzun olamaz"),
  erpBankCode: string()
    .max(50, "ERP Banka Kodu en fazla 50 karakter olabilir."),
  merchantId: string()
    .max(250, "Merchant ID/Public Key en fazla 250 karakter olabilir."),
  terminalId: string()
    .max(250, "Terminal ID/Private Key en fazla 250 karakter olabilir."),
});
